import { WorkReportType } from '../enums';

const workReportTypesInformation: { [key in WorkReportType]: string } = {
    [WorkReportType.TEAM_ALIGNMENT]: 'Team Alignment',
    [WorkReportType.CLIENT_ALIGNMENT]: 'Client Alignment',
    [WorkReportType.QA]: 'QA',
    [WorkReportType.DESIGN]: 'Design',
    [WorkReportType.REVISION]: 'Revision',
};

export default workReportTypesInformation;
